export default __webpack_public_path__ + "static/media/reportFlag.d20939f8.svg";